import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=5db232a8"
import script from "./ProjectDashboard.vue?vue&type=script&lang=ts"
export * from "./ProjectDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports